export const searchFormId = (courseIid) => `search_invite_targets_${courseIid}`;
